module.exports = __webpack_public_path__ + "static/media/emaiIIcon.adcef9bf.svg";